import { render } from "./history.vue?vue&type=template&id=41423350"
import script from "./history.vue?vue&type=script&lang=js"
export * from "./history.vue?vue&type=script&lang=js"

import "./history.vue?vue&type=style&index=0&id=41423350&lang=scss"

import exportComponent from "/Users/a/Desktop/app/pulizhenkong_pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__